export const paths = {
    playbookDetails: '/playbooks/:playbookId',
    playlistDetails: '/playlists/:playlistId',
    sharePlaybook: '/share/playbooks/:playbookId',
    sharePlaylist: '/share/playlists/:playlistId',
    gifDetails: '/gif/:playbookId',
    ssoLogin: '/ssologin'
}
